<template>
  <div class="ele-body">
    <el-card shadow="never">
      <ele-data-table ref="table" :config="table" :choose.sync="choose" highlight-current-row>
        <template>
          <el-table-column type="selection" width="45" align="center" />
          <el-table-column prop="gradeName" label="年级" show-overflow-tooltip />
          <el-table-column prop="teacherName" label="审核人" show-overflow-tooltip />
          <el-table-column label="操作" align="center">
            <template #default="{ row }">
              <el-link @click="openBindTeacher(row)" icon="el-icon-connection" type="primary" :underline="false">设置审核人</el-link>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>
    <!--设置审核人-->
    <el-dialog
      title="设置审核人"
      :visible.sync="showBindTeacher"
      width="400px"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <el-form :model="bindTeacherForm" ref="bindTeacherForm" :rules="rules" label-width="80px">
        <el-form-item label="教师" prop="teacherId">
          <el-select
            v-model="bindTeacherForm.teacherId"
            filterable
            remote
            reserve-keyword
            placeholder="请输入教师名称关键词"
            :remote-method="getTeacherList"
            @change="selectTeacher"
            :loading="loading"
          >
            <el-option v-for="item in teacherList" :key="item.id" :label="item.teacherName" :value="item.id">
              <span style="float: left">{{ item.teacherName }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.mobile }}</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showBindTeacher = false">取消</el-button>
        <el-button type="primary" @click="bingTeacher">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { getTeacherList } from '@/config/fengyi/api';
  import { auditTeacherSet } from '@/config/fengyi/fy_lea';

  export default {
    name: 'GradeList',
    data() {
      return {
        table: {
          // 表格配置
          url: '/fy/setting/getGradeList',
          method: 'GET',
          page: false,
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.data = res.data;
            return res;
          },
        },
        choose: [],
        showBindTeacher: false,
        bindTeacherForm: {
          teacherId: null,
          teacherName: null,
          auditLevel: 2,
          organizeId: null,
          organizeType: 2,
        },
        rules: {
          teacherId: [{ required: true, message: '请选择教师', trigger: 'blur' }],
          auditLevel: [{ required: true, message: '请选择审核级别', trigger: 'change' }],
        },
        teacherList: [],
        loading: false,
      };
    },
    methods: {
      openBindTeacher(row) {
        this.getTeacherList();
        this.bindTeacherForm.teacherId = row.teacherId;
        this.bindTeacherForm.teacherName = row.teacherName;
        this.bindTeacherForm.organizeId = row.id;
        console.log(this.bindTeacherForm);
        this.showBindTeacher = true;
      },
      // 获取教师列表
      getTeacherList(name) {
        this.loading = true;
        getTeacherList({ teacherName: name }).then((res) => {
          if (res.data.resCode == 200) {
            this.teacherList = res.data.data;
            this.loading = false;
          }
        });
      },
      // 选择教师
      selectTeacher(value) {
        let teacher = this.teacherList.find((item) => item.id == value);
        this.bindTeacherForm.teacherName = teacher.teacherName;
      },
      bingTeacher() {
        this.$refs['bindTeacherForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.bindTeacherForm) {
              if (this.bindTeacherForm[key] !== null && this.bindTeacherForm[key] !== undefined) {
                formData.append(key, this.bindTeacherForm[key]);
              }
            }
            auditTeacherSet(formData).then((res) => {
              loading.close();
              if (res.data.resCode == 200) {
                this.showBindTeacher = false;
                this.$message({ type: 'success', message: res.data.resMsg });
                this.$refs.table.reload();
              } else {
                this.$message.error(res.data.resMsg);
              }
            });
          } else {
            return false;
          }
        });
      },
    },
  };
</script>

<style scoped></style>
